import { navigate } from 'gatsby';

export const redirectToMainPage = (language: string): void => {
    typeof window !== 'undefined' && navigate(`/${language}/`);
};
